import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import { Picture } from 'ui-kit/picture'
import ImageMob1x from './hero-image-mob@1x.png'
import ImageMob2x from './hero-image-mob@2x.png'
import ImageDesk1x from './hero-image-desk@1x.png'
import ImageDesk2x from './hero-image-desk@2x.png'
import classes from './AIHero.module.scss'

export const AIHero = () => {
  return (
    <Block
      as={'section'}
      variant={'shadowMob'}
      pad={'baseMob'}
      divider={'mobile'}
      className={classes.section}
    >
      <hgroup className={classes.heading}>
        <Heading
          as={'h1'}
          size={'xxl'}
          center
          balance
          className={classes.title}
        >
          How we use AI
        </Heading>
        <Text size={'lg'} center balance className={classes.subtitle}>
          Harnessing the power of AI for building integrations while avoiding
          hallucinations and omissions.
        </Text>
      </hgroup>
      <div className={classes.visual}>
        <Picture
          mobSrc1x={ImageMob1x.src}
          mobSrc2x={ImageMob2x.src}
          deskSrc1x={ImageDesk1x.src}
          deskSrc2x={ImageDesk2x.src}
          width={356}
          height={544}
          alt='AI for building integrations'
          fetchPriorityHigh
        />
      </div>
      <Text size={'lg'} center balance className={classes.caption}>
        Generative AI can save 99% of time on building integrations, but only if
        put in a robust framework. You cannot (yet) ask LLM to build 100
        integrations for you and expect a good result, but you can ask it to
        perform a small task - like extracting an API request details from
        documentation - and get correct result almost every time.
      </Text>
    </Block>
  )
}
